import React, { Fragment } from 'react';
import { SwatchGroup } from './swatch-group';

class SwatchFilter extends React.Component{

    state={
        swatchGroups: []
    };

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.swatchGroups !== this.props.swatchGroups || prevProps.selectedSwatches != this.props.selectedSwatches){
            this.modifySwatchGroups();
        }
    }

    modifySwatchGroups = () => {
        const swatchGroups = this.props.swatchGroups.map((group)=>{
            const dict = {};
            const newGroup = Object.assign({}, group);
            let duplicatesCount = 0;
            newGroup.values = newGroup.values.reduce((newValues, swatch, i)=>{
                if(!dict.hasOwnProperty(swatch.value)){
                    dict[swatch.value] = i-duplicatesCount;
                    swatch.flag = "show";
                    newValues.push(swatch);
                }else{
                    newValues[dict[swatch.value]].variants.push(swatch.variants[0]);
                    duplicatesCount += 1;
                }
                return newValues;
            },[])
            return newGroup;
        })
        this.setState({ swatchGroups }, () => {
            //filtering after swatchGroups are updated
            const { selectedSwatches } = this.props;
            Object.keys(selectedSwatches).forEach(swatchKey=>{
                const selectedSwatch = selectedSwatches[swatchKey];
                const groupLevel = selectedSwatch.groupLevel;
                this.filterGroups(selectedSwatch, groupLevel);
            });
        });
    }
//filtering groups by their level
    filterGroups = (selectedSwatch, groupLevel) => {
        let newSwatchGroups = this.state.swatchGroups.slice();
        for(let i=groupLevel+1; i<newSwatchGroups.length;i++){
            let swatches =  newSwatchGroups[i].values;
            const selectedSwatchSkus = selectedSwatch.variants.map(variant=>variant.sku);
            const matchSelectedSkus = (sku) => selectedSwatchSkus.includes(sku);
            swatches.map((swatch)=>{
                 const skusDisabledMap = swatch.variants.reduce((dict, variant)=>{
                     dict[variant.sku] = variant.disabled;
                     return dict;
                 },{});
                 const swatchSkus = swatch.variants.map(variant=>variant.sku);
                 swatch.flag = swatchSkus.some(matchSelectedSkus) ? "show" : "hide";
                 //disabling swatch if needed
                 swatch.disabled = this.isDisabled(swatch, selectedSwatchSkus, skusDisabledMap, swatchSkus);
            });
        }
        this.setState({swatchGroups: newSwatchGroups});
    }

    isDisabled = (swatch, selectedSwatchSkus, skusDisabledMap, swatchSkus) => {
        if(swatch.flag === "show"){
            const commonSkus = swatchSkus.filter(sku => -1 !== selectedSwatchSkus.indexOf(sku));
            if(commonSkus.length === 1 && skusDisabledMap[commonSkus[0]]){
                return true;
            }else{
                let count = 0;
                commonSkus.forEach(sku=>{
                    if(skusDisabledMap[sku]){
                       count += 1;
                    }
                });
                if(count === commonSkus.length)return true;
            }
        }return false;
    }

    render(){
        const { swatchGroups } = this.state;
        const { selectedSwatches, selectSwatch } = this.props;
        return(
            <Fragment>
                {
                    swatchGroups.map((sG, index)=>
                        <SwatchGroup
                        	key={sG.key}
                        	swatchGroup={sG}
                        	selectSwatch={selectSwatch}
                        	selectedSwatch={selectedSwatches.hasOwnProperty(sG.key) ? selectedSwatches[sG.key] : {}}
                            level={index}
                        />)
                }
            </Fragment>
        );
    }
}

export default SwatchFilter;
